<template>
  <menu v-if="menu == 'default'" class="navigation-buttons">
    <v-btn
      v-for="item in menuItems"
      v-show="item.menu_item"
      :key="item.id"
      :to="item.home ? '/' : '/' + item.slug"
      v-bind="props"
      class="menu-item"
      :class="`menu-item-${item.id} ${props.class}`"
    >{{ item.name }}</v-btn>
  </menu>
  <menu v-else class="navigation-buttons">
    <component
      v-for="item in menuItems"
      :key="item.id"
      :is="
        item.children.length ? 'parent-menu-button' : `${item.type}-menu-button`
      "
      :props="props"
      :item="item"
      class="menu-item"
      :class="`menu-item-${item.id} ${props.class}`"
    ></component>
  </menu>
</template>

<script>
import { activeTemplate } from '@/graphql/template.gql'
import PageMenuButton from './PageMenuButton'
import SectionMenuButton from './SectionMenuButton'
import UrlMenuButton from './UrlMenuButton'
import ParentMenuButton from './ParentMenuButton'
import FileMenuButton from './FileMenuButton'

export default {
  name: 'BaseMenu',
  props: {
    menu: {
      type: String
    },
    props: {
      type: Object,
      required: true
    }
  },
  components: {
    PageMenuButton,
    SectionMenuButton,
    UrlMenuButton,
    ParentMenuButton,
    FileMenuButton
  },
  computed: {
    menuItems() {
      return this.menu == 'default'
        ? this.activeTemplate.pages
        : this.activeTemplate.menus
            .filter(menu => menu.id == this.menu)
            .map(menu => menu.parent_items)[0]
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    }
  }
}
</script>

<style>
.menu-item:not(.menu-active-style-default)::before {
  display: none;
}
.navigation-buttons > .menu-item {
  margin-left: 5px;
  margin-right: 5px;
}
.navigation-buttons > .menu-item:first-child {
  margin-left: 0 !important;
}
.navigation-buttons > .menu-item:last-child {
  margin-right: 0 !important;
}
.menu-item {
  min-width: 0 !important;
}
.menu-item .v-btn__content {
  border-bottom: 2px solid transparent;
  padding: 5px 0;
  transition: border 0.5s ease 0s, color 0.5s ease 0s, font-weight 0.5s ease 0s;
}
.menu-active-style-bold.v-btn--active .v-btn__content,
.menu-active-style-bold:hover .v-btn__content {
  font-weight: bold;
}
.menu-active-style-color-primary.v-btn--active .v-btn__content,
.menu-active-style-color-primary:hover .v-btn__content {
  color: var(--primary-color);
}
.menu-active-style-color-secondary.v-btn--active .v-btn__content,
.menu-active-style-color-secondary:hover .v-btn__content {
  color: var(--secondary-color);
}
.menu-active-style-color-accent.v-btn--active .v-btn__content,
.menu-active-style-color-accent:hover .v-btn__content {
  color: var(--accent-color);
}
.menu-active-style-underline.v-btn--active .v-btn__content,
.menu-active-style-underline.v-btn--active,
.menu-active-style-underline:hover .v-btn__content,
.menu-active-style-underline:hover {
  border-color: inherit;
}
.menu-active-style-underline-primary.v-btn--active .v-btn__content,
.menu-active-style-underline-primary.v-btn--active,
.menu-active-style-underline-primary:hover .v-btn__content,
.menu-active-style-underline-primary:hover {
  border-color: var(--primary-color);
}
.menu-active-style-underline-secondary.v-btn--active .v-btn__content,
.menu-active-style-underline-secondary.v-btn--active,
.menu-active-style-underline-secondary:hover .v-btn__content,
.menu-active-style-underline-secondary:hover {
  border-color: var(--secondary-color);
}
.menu-active-style-underline-accent.v-btn--active .v-btn__content,
.menu-active-style-underline-accent.v-btn--active,
.menu-active-style-underline-accent:hover .v-btn__content,
.menu-active-style-underline-accent:hover {
  border-color: var(--accent-color);
}
</style>
